// signal
// ======

export const YIELD = 'yield'

export const DONE = 'done'

export const FAULTED = 'faulted'

export const SUSPEND = 'suspend'
